import { routerStore } from '~/modules/stores/routerStore';
import { handleException } from '~/modules/utilities/error_utilities';
import { http } from '~/modules/utilities/http';

let pageInitialRender = false;
let loadEventFired = false;
let metricsSent = false;

async function sendLoadMetrics() {
    if (!metricsSent && pageInitialRender && loadEventFired) {
        metricsSent = true;

        const [navigationEntry] = performance.getEntriesByType('navigation') as PerformanceNavigationTiming[];
        const path = routerStore.getState().url;
        const url = '/api/metrics/load';
        const body = {
            path,
            domInteractiveMs: navigationEntry.domInteractive,
            totalLoadMs: performance.now() - navigationEntry.startTime,
        };

        try {
            await http.post(url, {
                data: body,
            });
        } catch (err) {
            handleException(err, 'metricsService.sendLoadMetrics');
        }
    }
}

export function registerLoadEvent() {
    window.addEventListener('load', function () {
        setTimeout(async () => {
            loadEventFired = true;
            await sendLoadMetrics();
        }, 0);
    });
}

export async function initialPageRenderedMetricsCheck() {
    pageInitialRender = true;
    await sendLoadMetrics();
}
